<template>
  <v-row>
    <v-col cols="12">
      <ComponentsFixedBar :minimized-side-menu="minimizedSideMenu" :title="$t('general.lists')"/>
    </v-col>

    <v-col cols="12" class="pb-0" style="padding-top: 50px">
      <span class="kbDarkBlueText--text">
        {{ $t('general.note') }}: {{ $t('general.onlyStaticListsAreListedBelow') }}
      </span>
    </v-col>

    <v-col cols="12" class="d-flex align-center">
      <v-select v-model="selectedList"
                background-color="kbLight"
                color="kbDarkBlue"
                hide-details
                :items="staticLists"
                item-text="name"
                item-value="_id"
                :label="$t('general.addToList')"
                solo>
        <template #append-outer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn :color="mainColor"
                     dark
                     icon
                     :loading="addingUserToList">
                <v-icon size="40px"
                        @click="addUserToList()"
                        v-on="on">
                  mdi-plus-circle
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('general.addToList') }}</span>
          </v-tooltip>
        </template>
      </v-select>
    </v-col>
  </v-row>
</template>

<script>
import notifications from '@/libs/notifications'
import { mapState } from 'vuex'
import ComponentsFixedBar from '@/pages/App/People/dialogs/ViewUser/ComponentsFixedBar'
export default {
  components: { ComponentsFixedBar },
  computed: {
    ...mapState({
      lists: state => state.listsPersons.listsPersons
    }),
    staticLists () {
      return this.lists.filter(item => item.type === 'static')
    }
  },
  data () {
    return {
      addingUserToList: false,
      selectedList: ''
    }
  },
  methods: {
    async addUserToList () {
      if (this.addingUserToList) return
      if (!this.selectedList) return notifications.error(this.$t('general.pickAList'))
      this.addingUserToList = true
      try {
        await this.$store.dispatch('addUserToList', { userId: this.userId, listId: this.selectedList })
        notifications.success(this.$t('general.personAddedToList'))
        this.addingUserToList = false
        this.selectedList = ''
        return true
      } catch (e) {
        notifications.error(e.message)
        this.addingUserToList = false
      }
    }
  },
  props: {
    mainColor: {
      type: String
    },
    minimizedSideMenu: {
      type: Boolean,
      required: true
    },
    userId: {
      type: String
    }
  }
}
</script>

<style scoped>
  ::v-deep.v-text-field.v-text-field--solo .v-input__append-outer {
    margin: auto 10px auto!important;
  }
</style>
